import { Module } from 'vuex'
import _ from 'lodash'
import { t } from '@/lang'
import { RootState } from '@ps/types/store'
import { getGmakerProjectInfo } from '@pt/api/gmaker/project.js'
import { getPSProjectInfo } from '@ps/api/project.js'
import shortid from 'shortid'

interface deliveryModel {
  creativePreviewerDialog: {
    visible: boolean
  }
  creativePreviewer: any
}

const deliveryModule: Module<deliveryModel, RootState> = {
  namespaced: true,

  state: {
    creativePreviewerDialog: {
      visible: false,
    },
    creativePreviewer: {},
  },

  mutations: {
    closeCreativePreviewerDialog(state) {
      state.creativePreviewerDialog.visible = false
      // 延迟 300 ms 清空数据
      window.setTimeout(() => {
        state.creativePreviewer = {}
      }, 300)
    },
  },

  actions: {
    async previewPlayable({ state }, data) {
      if (!data.source_id || !data.product_name) {
        throw new Error('source_id/product_name is required')
      }

      const cookCreatives = (el: any) => {
        const temp: any[] = []
        JSON.parse(el.groups).map((k: any) => {
          const item = { ...el }
          item.gid = k.gid
          item.dco_ids = item.id
          item.name = item.gid
          delete item.id
          temp.push(item)
        })
        return temp
      }

      const sourceId = data.source_id // 用于展示
      const info = {
        // 产品名字
        name: data.product_name,
        tag: undefined,
        detail: [
          {
            value: sourceId,
            label: t('playTurbo.common.previewDialog.playable') + '：',
          },
        ],
      }

      if (data.detail) {
        info.detail = data.detail
      }
      // 有 preview_url 代表是预览单个资源
      if (data.preview_url && typeof data.preview_url === 'string') {
        if (data.skin_id) {
          // 如果还有皮肤 id 则需要从接口获取最新的预览链接
          state.creativePreviewer = {
            creatives: [
              {
                id: 1,
                preview_url: data.preview_url,
                creative_type: 3,
              },
            ],
            source_id: data.source_id,
            skin_id: data.skin_id,
            currentCreativeId: 1,
            info,
            switcherVisible: false,
          }
        } else {
          state.creativePreviewer = {
            creatives: [
              {
                id: 1,
                preview_url: data.preview_url,
                creative_type: 3,
              },
            ],
            custom_id: data.custom_id,
            currentCreativeId: 1,
            info,
            switcherVisible: false,
          }
        }
        state.creativePreviewerDialog.visible = true
      } else if (data.preview_url && typeof data.preview_url === 'object') {
        //
        info.detail = []
        const list = data.preview_url.map((url: string, index: number) => {
          return {
            id: index + 1,
            name: 'playable' + (index + 1),
            preview_url: url,
            creative_type: 3,
          }
        })
        state.creativePreviewer = {
          creatives: list,
          custom_id: data.custom_id,
          currentCreativeId: 1,
          info,
          switcherVisible: list.length > 1,
        }
        state.creativePreviewerDialog.visible = true
      } else {
        let res
        if (
          data.project_type === 'playsmart' ||
          data.pageType === 'myTemplate'
        ) {
          res = await getPSProjectInfo({
            id: data.custom_id,
          })
        } else if (data.isCommonTemplate) {
          res = await getGmakerProjectInfo({
            project_id: data.custom_id,
          })
        }
        let list
        if (data.project_type === 'dco') {
          list = _.get(res, 'data.data.dco_creatives')
            ? cookCreatives(_.get(res, 'data.data.dco_creatives')[0])
            : []
        } else {
          list = _.get(res, 'data.data.groups_config')
            ? JSON.parse(_.get(res, 'data.data.groups_config'))
            : []
        }

        if (list.length > 0) {
          const temp = list.map((item: any) => {
            // 列表内容处理
            return {
              id: shortid(),
              ...item,
              creative_type: 3,
            }
          })
          state.creativePreviewer = {
            creatives: temp,
            custom_id: data.custom_id,
            currentCreativeId: temp[0].id,
            info,
            switcherVisible: list.length > 1,
          }
        } else {
          if (data.project_type === 'playsmart') {
            info.detail = []
          }
          state.creativePreviewer = {
            creatives: [
              {
                id: 1,
                name: '默认组合',
                preview_url: data.template_url,
                creative_type: 3,
              },
            ],
            custom_id: data.custom_id,
            currentCreativeId: 1,
            info,
            switcherVisible: false,
          }
        }
        state.creativePreviewerDialog.visible = true
      }
    },
  },
}

export default deliveryModule
